import React, { useState, useEffect } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  DoorOpen,
  MapPin,
  ArrowLeft,
  Save,
  PlusCircle,
  Layout,
  Info,
  ShieldCheck
} from "lucide-react";
import { Formik, Form, Field } from "formik";
import { addDoor, getAllDoors } from "../../store/actions";
import {
  Button,
  Input,
  Select,
  Tabs,
  Breadcrumb,
  useToast,
  Card
} from "../UI";
import { axiosConfig } from "../../config/index";
import { DoorLocationValidationSchema } from "../../validations/index";

const AddDoor = ({ addDoor, history }: any) => {
  const { toast } = useToast();
  const [siteItems, setSiteItems] = useState<any>([]);

  useEffect(() => {
    axios.get(`/api/sites/getallsite/`, axiosConfig)
      .then((response: any) => {
        setSiteItems(response.data);
      })
      .catch((err: any) => console.error(err));
  }, []);

  const siteOptions = siteItems.map((op: any) => ({
    label: op.sitename,
    value: op.id || op._id
  }));

  const tabs = [
    {
      id: 'details',
      icon: <Info className="w-4 h-4" />,
      content: (
        <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
          <div className="grid grid-cols-1 md:grid-cols-1 gap-8 max-w-sm">
            <div className="space-y-6">
              <Field name="siteId">
                {({ field, form, meta }: any) => (
                  <Select
                    label="Associated Site"
                    placeholder="Select a site..."
                    options={siteOptions}
                    value={field.value}
                    onChange={(val) => form.setFieldValue("siteId", val)}
                    error={meta.touched && meta.error ? meta.error : ""}
                    searchable
                    required
                  />
                )}
              </Field>

              <Field name="alloweddoor">
                {({ field, form, meta }: any) => (
                  <Input
                    {...field}
                    label="Door Name / ID"
                    placeholder="e.g. Server Room Main Entrance"
                    error={meta.touched && meta.error ? meta.error : ""}
                    required
                  />
                )}
              </Field>

            </div>

          </div>

          {/* <div className="space-y-6">
              <div className="p-4 bg-[#8dc63f]/10/50 rounded-2xl border border-[#8dc63f]/20 flex gap-4">
                <div className="p-2 bg-white rounded-xl shadow-sm h-fit">
                  <ShieldCheck className="w-4 h-4 text-[#8dc63f]" />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-bold text-slate-700">Security Mapping</p>
                  <p className="text-xs font-medium text-[#8dc63f]/70 leading-relaxed">
                    Door names should be descriptive and match physical labeling to avoid confusion during emergency response.
                  </p>
                </div>
              </div>

              <div className="p-4 bg-slate-50 rounded-2xl border border-slate-100 flex gap-4 opacity-60">
                <div className="p-2 bg-white rounded-xl shadow-sm h-fit">
                  <MapPin className="w-4 h-4 text-slate-400" />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-bold text-slate-600">Geo-fencing (Soon)</p>
                  <p className="text-xs font-medium text-slate-400 leading-relaxed">
                    GPS coordinates for mobile-based proximity unlocking will be available in the next firmware update.
                  </p>
                </div>
              </div>
            </div> */}
          {/* </div> */}
        </div >
      )
    }
  ];

  return (
    <div className="max-w-md space-y-8">
      <div className="flex flex-col gap-4">
        <Breadcrumb
          items={[
            { label: 'Home', to: '/dashboard' },
            { label: 'Doors', to: '/doorlist' },
            { label: 'Add Door' }
          ]}
        />

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-[#8dc63f] rounded-2xl shadow-lg shadow-[#8dc63f]/30">
              <DoorOpen className="w-6 h-6 text-white" />
            </div>

            <h1 className="text-2xl font-bold text-slate-900 tracking-tight leading-none">Add Door</h1>

          </div>

          <Link to="/doorlist">
            <Button variant="ghost" className="gap-2 text-slate-400 hover:text-slate-900">
              <ArrowLeft className="w-4 h-4" />
              Back to List
            </Button>
          </Link>
        </div>
      </div>

      <Formik
        initialValues={{
          siteId: "",
          alloweddoor: "",
        }}
        validationSchema={DoorLocationValidationSchema}
        onSubmit={async (values, { setErrors, resetForm, setSubmitting }) => {
          try {
            await addDoor(values);
            toast("Door created successfully", "success");
            resetForm({});
            history.push("/doorlist");
          } catch (error: any) {
            toast(error.message || "Failed to create door", "error");
            setErrors(error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit} className="space-y-8">
            <Card>
              {tabs[0].content}
            </Card>
            {/* <hr className="border-t border-slate-200 my-2 opacity-50" /> */}

            <div className="flex items-center justify-end gap-3 pt-4 px-1">
              <Link to="/doorlist">
                <Button type="button" variant="ghost" className="h-10 px-8">Cancel</Button>
              </Link>
              <Button
                type="submit"
                className="h-10 px-10 gap-2 shadow-xl shadow-[#8dc63f]/20 bg-[#8dc63f] hover:bg-[#76ab32]"
                disabled={isSubmitting}
              >
                <Save className="w-4 h-4" />
                {isSubmitting ? 'Registering...' : 'Register Door'}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  getAllDoors,
  addDoor,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddDoor);



